export const OfficeCreateInstallationState = {
	url: '/installation/create',
	title: 'Office Installation - Create',
	template: '<office-installation-create-page></office-installation-create-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeInstallationCreatePageMod" */
			'@Containers/office-installation-page/office-create-installation/office-create-installation.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
